module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBbaIe17AAAASUlEQVQ4y2P4jwQ+MAww7wADDNgPEh7/n0HB4weGzwEG5v+Dhff/wyDh/YEG1SDggQKIAei8wcADuQyYoRgGA28Q5GIYb/CUdQCyqsTflwg8UgAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOC0wOC0xM1QxNToyNzowOSswOTowMLb14X8AAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTMtMTAtMDhUMDY6MDg6MjIrMDk6MDA/qCjNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h10/tag36_10_01198_100x100.png
// module id = bDe7
// module chunks = 0